import axios from 'axios';

import ApiCore from '../Utils/ApiCore';
import ApiPathMgr from '../Utils/ApiPathMgr';
import DashApiConfig from '../Utils/DashApiConfig';

import AdminApi from './admin/AdminApi';
import AuthApi from './auth/AuthApi';
import ListingsApi from './listings/ListingsApi';
import BlogApi from './blog/BlogApi';
import GeoApi from './geo/GeoApi';
import UsersApi from './users/UsersApi';

export default class DashApi {

    constructor(dashApiCfg, authToken) {

        if (!(dashApiCfg instanceof DashApiConfig)) {
            dashApiCfg = new DashApiConfig(dashApiCfg);
        }

        this.apiConfig = dashApiCfg;
        this.authToken = authToken;

        this.CORE =  new ApiCore(dashApiCfg, authToken);
        this.ApiPathMgr = new ApiPathMgr();

        this.Admin = new AdminApi(this);
        this.Auth = new AuthApi(this);

        this.Blog = new BlogApi(this);
        this.Geo = new GeoApi(this);
        this.ListingsApi = new ListingsApi(this);
        this.Users = new UsersApi(this);
    }

    setAuthToken(authToken) {
        this.authToken = authToken;
        this.CORE = new ApiCore(this.apiConfig, this.authToken);
    }

}



// WEBPACK FOOTER //
// ./src/DashApi/index.js


// WEBPACK FOOTER //
// webpack:///src/DashApi/index.js